/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Group112 from "../Group112";
import "./Web192024.css";

function Web192024(props) {
  const { group138, path128, group112Props } = props;

  return (
    <div className="container-center-horizontal">
      <div className="web-1920-24 screen">
        <div className="group-container-6">
          <Group112 className={group112Props.className} />
          <div className="group-257">
            <div className="group-256">
              <div className="overlap-group-15">
                <div className="group-141-2">
                  <div className="group-140-2">
                    <div className="group-139-2">
                      <img className="group-138-2" src={group138} />
                    </div>
                  </div>
                </div>
                <img className="path-128-2" src={path128} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Web192024;
